<div id="wrapper">
    <app-loading-screen [status]=true>
    </app-loading-screen>
    <div class="allcont">
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
        <div style="margin-bottom: 0px;">
            <app-tab-nav (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event" (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event" (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
                (updateInitializeData)="this.initializeData()">
            </app-tab-nav>
        </div>
        <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
        <div class="basicrow mbott" *ngIf="this.totalAccountList> 0">
            <div class="container">
                <div class="fulltitle m-top-i f-btitle">
                    <span class="icon-dash-01"></span> Descarga tu Factura
                </div>
                <div class="basicrow m-top">
                    <div class="autowcont m-bott">
                        <div class="basicrow msidespad border-bottom">
                            <div class="b-title noline">
                                <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                                    <div class="tabcell">
                                        Descarga Tu Factura
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="basicrow">
                            <div class="basicrow allpads">
                                <div class="basicrow">
                                    <div class="autorow subsc pull-left mob-wid">
                                        <label class="label-r">Filtro de Busqueda:</label>
                                        <div class="basicrow">
                                            <div>
                                                <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f" style="background-image:url(/assets/images/selectabarrw.png)">
                                                  <option *ngFor="let list of this.currentList"
                                                    [ngValue]="list.account">{{list.account}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="autorow subsc pull-left mleft-select">
                                        <label class="label-r">Año:</label>
                                        <div class="basicrow">
                                            <select (change)="updateBillsChange()" [(ngModel)]="selectYear" class="sel-f yearSelect" style="background-image:url(/assets/images/selectabarrw.png)">
                                              <option disabled value="">Año</option>
                                              <option *ngFor="let year of this.yearList"
                                                [ngValue]="year">{{year}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="autorow subsc pull-left mleft-select">
                                        <label class="label-r">Formato:</label>
                                        <div class="basicrow">
                                            <select (change)="updateBillsChange()" [(ngModel)]="this.format" class="sel-f yearSelect" style="background-image:url(/assets/images/selectabarrw.png)">
                                              <option disabled value="">Formato</option>
                                              <option value="pdf">PDF</option>
                                              <option value="csv">CSV</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="basicrow msidespad roboto-b f-black f-reg m-bott">
                                <div class="basicrow topbord">
                                    Factura Actual
                                </div>
                            </div>
                            <div class="basicrow visible-web">
                                <div class="tab-tbar">
                                    <div class="frwds rline vcenter">
                                        <div class="tabcell">
                                            Fecha de Facturaci&oacute;n
                                        </div>
                                    </div>
                                    <div class="frwds rline vcenter">
                                        <div class="tabcell">
                                            Vencimiento
                                        </div>
                                    </div>
                                    <div class="frwds rline vcenter">
                                        <div class="tabcell">
                                            Cantidad
                                        </div>
                                    </div>
                                    <div class="frwds vcenter">
                                        <div class="tabcell">
                                            Ver
                                        </div>
                                    </div>
                                </div>
                                <div class="basicrow">
                                    <div class="tab-cbar" *ngFor="let invoice of this.invoices; let i= index">
                                        <div class="frwds rline vcenter">
                                            <div class="tabcell">
                                                {{invoice.BillDate}}
                                            </div>
                                        </div>
                                        <div class="frwds rline vcenter">
                                            <div class="tabcell" *ngIf="invoice.DueDate!='--'">
                                                {{invoice.DueDate}}
                                            </div>
                                        </div>
                                        <div class="frwds rline vcenter">
                                            <div class="tabcell" *ngIf="invoice.AmountDue!='--'">
                                                ${{invoice.AmountDue}}
                                            </div>
                                        </div>
                                        <div class="frwds vcenter">
                                            <div class="tabcell">
                                                <div class="actbtn" *ngIf="this.format=='pdf'">
                                                    <a (click)="this.openPDF(invoice.key,invoice.BillDate)" >
                                                        <i data-toggle="popover" data-html="true" data-content="PDF" data-placement="top" data-trigger="hover" class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                    </a>
                                                </div>
                                                <div class="actbtn" *ngIf="this.format=='csv'">
                                                    <a (click)="this.openCSV(invoice.key,invoice.BillDate)" >
                                                        <i data-toggle="popover" data-html="true" data-content="CSV" data-placement="top" data-trigger="hover" class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="basicrow m-top visible-movil">
                                <div class="basicrow" id="last-div">
                                    <div id="myCarousel5" class="carousel slide" data-interval="false" data-ride="carousel">
                                        <div class="carousel-inner">
                                            <carousel [interval]="false">
                                                <slide>
                                                    <div class="item active">
                                                        <div class="boxtbl">
                                                            <div class="tab-tbar">
                                                                <div class="frwds rline vcenter">
                                                                    <div class="tabcell">
                                                                        Fecha de Facturaci&oacute;n
                                                                    </div>
                                                                </div>
                                                                <div class="frwds vcenter">
                                                                    <div class="tabcell">
                                                                        Vencimiento
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="basicrow">
                                                                <div class="tab-cbar" *ngFor="let invoice of this.invoices; let i= index">
                                                                    <div class="frwds rline vcenter">
                                                                        <div class="tabcell">
                                                                            {{invoice.BillDate}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="frwds vcenter">
                                                                        <div class="tabcell" *ngIf="invoice.DueDate!='--'">
                                                                            {{invoice.DueDate}}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </slide>
                                                <slide>
                                                    <div class="item">
                                                        <div class="boxtbl">
                                                            <div class="tab-tbar">
                                                                <div class="frwds rline vcenter">
                                                                    <div class="tabcell">
                                                                        Cantidad
                                                                    </div>
                                                                </div>
                                                                <div class="frwds vcenter">
                                                                    <div class="tabcell">
                                                                        Ver
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="basicrow">
                                                                <div class="tab-cbar" *ngFor="let invoice of this.invoices; let i= index">
                                                                    <div class="frwds rline vcenter">
                                                                        <div class="tabcell" *ngIf="invoice.AmountDue!='--'">
                                                                            ${{invoice.AmountDue}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="frwds vcenter">
                                                                        <div class="tabcell">
                                                                            <div class="actbtn">
                                                                                <a (click)="this.openPDF(invoice.key,invoice.BillDate)" *ngIf="this.format=='pdf'">
                                                                                    <i data-toggle="popover" data-html="true" data-content="PDF" data-placement="top" data-trigger="hover" class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                                                </a>
                                                                                <a (click)="this.openCVS(invoice.key,invoice.BillDate)" *ngIf="this.format=='csv'">
                                                                                    <i data-toggle="popover" data-html="true" data-content="PDF" data-placement="top" data-trigger="hover" class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </slide>
                                            </carousel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="basicrow m-top-u allpads bordsdef f-reg roboto-r f-black text-justify">
                        <span class="roboto-b">Servicio al Cliente</span><br /><br /> Escr&iacute;banos por nuestro Chat para recibir asesor&iacute;a inmediata. Individual: <span class="roboto-b">787-775-0000</span> &oacute; marcando <span class="roboto-b">&#42;611</span>                        desde tu tel&eacute;fono celular.
                    </div>
                    <div class="basicrow m-top-i bg-gray allpads bg-gray-u f-reg roboto-r f-black text-justify">
                        <span class="roboto-b">Hist&oacute;rico de facturas</span><br /><br /> El hist&oacute;rico de facturas le permite ver hasta sus &uacute;ltimas trece (13) facturas. Para revisarlas s&oacute;lo se necesita seleccionar el formato
                        en que desea ver la factura bajo la columna
                        <span class="roboto-b">Ver Como
                        </span> y oprimir el bot&oacute;n. Cabe se&ntilde;alar que s&oacute;lo se desplegar&aacute;n las primeras quinientas (500) p&aacute;ginas de la factura, cuando aplique. Si desea revisar la factura completa,
                        debe comunicarse con <a routerLink="/support" target="_blank">Servicio al Cliente.</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>